import axios, { AxiosRequestConfig } from 'axios'
import _ from 'lodash'
import { MockApiItem, RequestInstance, RequestType } from './types'

/**
 * ！！！警告
 * 原则上中间件不允许替换 request 对像
 * 但是这里的 request 是可直接使用的函数
 */

export function createRequestInstance(config: AxiosRequestConfig): RequestInstance {
  // TODO 内部处理的 as 和 any 后期要处理掉
  const request = axios.create(config)
  const mockApis: MockApiItem[] = []
  const newRequest: any = (currentConfig: AxiosRequestConfig) => {
    return mockRequest(request, mockApis, [currentConfig], currentConfig.url, currentConfig.method || 'get', null)
  }
  Object.assign(newRequest, request, {
    mockApis,
  })

  const requestInstance = newRequest as RequestInstance;

  ['delete', 'get', 'head', 'options', 'put', 'post', 'patch', 'request'].forEach((funcName: string) => {
    const originMethod: RequestType = (requestInstance as any)[funcName];
    (request as any)[funcName] = async (...args: any[]) => {
      let url = args[0]
      let requestMethod = funcName
      if (funcName === 'request') {
        url = args[0].url
        // AxiosRequestConfig 同时允许 method 大小写
        requestMethod = args[0].method || 'get'
      }
      return mockRequest(originMethod, mockApis, args, url, requestMethod, request)
    }
  })

  requestInstance.registerMockApis = (items: MockApiItem[]) => {
    // 防止重复注册
    requestInstance.unregisterMockApis(items)
    mockApis.push(...items)
  }
  // 移除注册
  requestInstance.unregisterMockApis = (items: MockApiItem[]) => {
       items.forEach((item: MockApiItem) => {
      _.remove(mockApis, item)
    })
  }
  return requestInstance
}

async function mockRequest(originMethod: any,
                           mockApis: MockApiItem[],
                           args: any[],
                           url: string | undefined,
                           requestMethod: string,
                           owner: any) {
  const mockApi = mockApis.find((item: MockApiItem) => {
    return isMatchMockRule(url, requestMethod, item)
  })
  if (mockApi) {
    const { default: mockReturn } = await mockApi.resp()
    // !!! 警告 原则上禁止强制类型转换
    // tslint:disable-next-line:no-console
    console.warn(`mock api (method: ${requestMethod}, url: ${url})  `)
    return (mockReturn as any).apply(owner, args as any)
  }
  return originMethod.apply(owner, args as any)
}

/**
 * 是否匹配 指定 mock 规则
 * @param url
 * @param requestMethod
 * @param item
 */
function isMatchMockRule(url: string | undefined, requestMethod: string, item: MockApiItem) {
  if (!url) {
    // url 不匹配
    return false
  }
  if (item.method.toLowerCase() !== requestMethod.toLowerCase()) {
    // request method 不匹配
    return false
  }

  if (_.isFunction(item.pattern)) {
    return item.pattern(url)
  }
  return item.pattern.test(url)
}
